import React, { useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import ColumnsLayout from '../Layout/ColumnsLayout';
import TradeListHeader from '../../components/TradeList/TradeListHeader';
import { StyledNavSecondaryContainer } from '../../components/NavSecondary/Styles';
import TradeListFooter from '../../components/TradeList/TradeListFooter';
import useCurrentTradeState from '../../_shared/hooks/trade/useCurrentTradeState';
import ClosingHighBid from '../../components/Closing/ClosingHighBid';
import ClosingOutBid from '../../components/Closing/ClosingOutBid';
import SellingClosing from '../../components/Closing/SellingClosing';
import useIsSellContext from '../../_shared/hooks/trade/useIsSellContext';
import TradeFilterBar from '../../components/TradeFilterBar';
import useTradeSort from '../../_shared/hooks/trade/sort/useTradeSort';
import NavSecondary from '../../components/NavSecondary';
import { TradeContext } from '../../_shared/types/trade';
import useCurrentTradeContext from '../../_shared/hooks/trade/useCurrentTradeContext';

const Closing = () => {
  const tradeState = useCurrentTradeState();
  const tradeContext = useCurrentTradeContext();
  const isSellContext = useIsSellContext();
  const [activeNetwork, selectedSortOption] = useSelector(
    state => [
      state?.filter?.activeFilter,
      state?.filter?.previewCriteria,
      state?.filter?.activeNetwork?.[tradeState],
      state?.ui?.tradeSort?.[tradeState]
    ],
    shallowEqual
  );
  const filtersButtonRef = useRef(null);
  const setSortOption = useTradeSort();

  const getSubHeading = () => {
    switch (tradeContext) {
      case TradeContext.Buy:
        return <FormattedMessage id="list.header.buy.closing.subheading" />;
      case TradeContext.Sell:
        return <FormattedMessage id="list.header.sell.closing.subheading" />;
      default:
        return null;
    }
  };

  const getColumns = () => {
    switch (tradeContext) {
      case TradeContext.Buy:
        return [<ClosingOutBid />, <ClosingHighBid />];
      case TradeContext.Sell:
        return [<SellingClosing />];
      default:
        return null;
    }
  };

  const getFilterBar = () => {
    if (isSellContext) {
      return (
        <TradeFilterBar
          selectedSortOption={selectedSortOption}
          setSortOption={setSortOption}
          tradeState={tradeState}
          filtersButtonRef={filtersButtonRef}
          showLayoutToggle={false}
          showSortOptions={false}
        />
      );
    }
    return null;
  };

  return (
    <>
      <NavSecondary tradeState={tradeState} />
      <StyledNavSecondaryContainer>
        <ColumnsLayout
          header={<TradeListHeader tradeState={tradeState} />}
          filterBar={getFilterBar()}
          subheading={getSubHeading()}
          columns={getColumns()}
          footer={
            <TradeListFooter
              tradeState={tradeState}
              activeNetwork={activeNetwork}
            />
          }
        />
      </StyledNavSecondaryContainer>
    </>
  );
};

export default Closing;
